import { render, staticRenderFns } from "./TelecomsDetails.vue?vue&type=template&id=03b35b28&"
import script from "./TelecomsDetails.vue?vue&type=script&lang=js&"
export * from "./TelecomsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TelecomsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports